function caculateTotalLinePrice() {
  const inputQuanty = document.querySelector("input.quantity__input");
  if (inputQuanty) {
    let htmlTagPattern = /<\/?[^>]+(>|$)/;
    const priceItem = document.querySelector(
      "span.price-item[bss-b2b-variant-price]"
    );
    if (priceItem && !htmlTagPattern.test(priceItem.innerHTML)) {
      let str = priceItem.innerHTML.substring(1);
      let price = parseFloat(str.replace(",", "."));
      if (!isNaN(price)) {
        const qty = inputQuanty.value;
        const newTotal = (price * qty).toFixed(2);
        const totals = document.querySelectorAll('.bss-custom-cart')
        if(totals.length) {
          totals.forEach((total) => {
            // console.log(total)
            total.innerHTML = priceItem.innerHTML.charAt(0) + newTotal
          })
        }
      }
    }
  }
}

window.addEventListener("cart_changed", () => {
  setTimeout(() => {
    caculateTotalLinePrice()
    BSS_B2B.changeProductPriceWithInterval()
    if(BSS_B2B.page.isCartPage()) {
      BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false)
    }
  }, 600);
});

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener("bss_b2b_doneCheckCp", () => {
      caculateTotalLinePrice()
    })
})

if(window.location.pathname.includes("/collections/")) {
  const filterCheckboxes = document.querySelectorAll(".facets__form input[type='checkbox']");

  filterCheckboxes.forEach(function (item) {
    item.addEventListener("click", function () {
      window.location.reload();
    });
  })
}